module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Vagrant")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#can-we-create-serendipity"
    }
  }, [_vm._v("Can We Create Serendipity?")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#mania-is-good-friend-to-my-cousin-anxiety"
    }
  }, [_vm._v("Mania Is Good Friend to My Cousin Anxiety")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#firsts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Firsts")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#hysterical-women-dont-last-as-long",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hysterical Women Don’t Last as Long")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#firecrackers-fizzle-out-under-sheets",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Firecrackers Fizzle-out Under Sheets")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#doing-it-for-the-girls",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Doing It for the Girls")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#is-hope-just-seduction",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is Hope Just Seduction?")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#have-you-ever-danced-with-fire-and-come-out-frozen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Have You Ever Danced with Fire and Come Out Frozen?")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#right-and-wrong-and-moving-on",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Right and Wrong and Moving On")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#silver-linings-have-hollow-centres",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silver Linings Have Hollow Centres")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#its-all-swings-and-roundabouts-kid",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s All Swings and Roundabouts Kid…")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#nothing-matters-if-you-say-it-doesnt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nothing Matters If You Say It Doesn’t")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#yes-sir-no-sir-three-bags-full-sir",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yes Sir, No Sir, Three Bags Full Sir")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#i-hate-even-numbers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Hate Even Numbers")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0